const pageNameKey = "autoGenerateCertificateSetting";

export const autoGenerateCertificateSettingEn = {
  [pageNameKey]: {
    labelText: "Automatically generate certificate",
    uploadInfoText:
      "Uploading a certificate here only registers it in Things OS. You also need to upload or approve the same certificate on the target machine, or the connection will fail.",
    generatedInfoText:
      "Generating or uploading a certificate here only registers it in Things OS. You also need to upload or approve the same certificate on the target machine, or the connection will fail.",
    reuseGeneratedCertificateHintText:
      "Generated certificate will be used again.",
    infoIconAltText: "Info",
  },
};

export const autoGenerateCertificateSettingPtBr = {
  [pageNameKey]: {
    labelText: "Gerar certificado automaticamente",
    uploadInfoText:
      "Ao enviar um certificado aqui, ele e registrado apenas no Things OS. Voce tambem precisa enviar ou aprovar o mesmo certificado na maquina de destino, caso contrario a conexao falhara.",
    generatedInfoText:
      "Ao gerar ou enviar um certificado aqui, ele e registrado apenas no Things OS. Voce tambem precisa enviar ou aprovar o mesmo certificado na maquina de destino, caso contrario a conexao falhara.",
    reuseGeneratedCertificateHintText: "O certificado gerado sera reutilizado.",
    infoIconAltText: "Informacao",
  },
};

export const autoGenerateCertificateSettingDe = {
  [pageNameKey]: {
    labelText: "Zertifikat automatisch erzeugen",
    uploadInfoText:
      "Das Hochladen eines Zertifikats hier registriert es nur in Things OS. Sie muessen dasselbe Zertifikat auch auf der Zielmaschine hochladen oder bestaetigen, sonst schlaegt die Verbindung fehl.",
    generatedInfoText:
      "Das Erzeugen oder Hochladen eines Zertifikats hier registriert es nur in Things OS. Sie muessen dasselbe Zertifikat auch auf der Zielmaschine hochladen oder bestaetigen, sonst schlaegt die Verbindung fehl.",
    reuseGeneratedCertificateHintText:
      "Das erzeugte Zertifikat wird erneut verwendet.",
    infoIconAltText: "Info",
  },
};

export const autoGenerateCertificateSettingZhHans = {
  [pageNameKey]: {
    labelText: "自动生成证书",
    uploadInfoText:
      "在此上传证书只会将其注册到 Things OS。您还需要在目标机器上上传或批准同一证书，否则连接将失败。",
    generatedInfoText:
      "在此生成或上传证书只会将其注册到 Things OS。您还需要在目标机器上上传或批准同一证书，否则连接将失败。",
    reuseGeneratedCertificateHintText: "将再次使用已生成的证书。",
    infoIconAltText: "信息",
  },
};

export const autoGenerateCertificateSettingIt = {
  [pageNameKey]: {
    labelText: "Genera automaticamente il certificato",
    uploadInfoText:
      "Caricare un certificato qui lo registra solo in Things OS. Devi anche caricare o approvare lo stesso certificato sulla macchina di destinazione, altrimenti la connessione non riuscira.",
    generatedInfoText:
      "Generare o caricare un certificato qui lo registra solo in Things OS. Devi anche caricare o approvare lo stesso certificato sulla macchina di destinazione, altrimenti la connessione non riuscira.",
    reuseGeneratedCertificateHintText:
      "Il certificato generato verra riutilizzato.",
    infoIconAltText: "Informazioni",
  },
};

export const autoGenerateCertificateSettingEs = {
  [pageNameKey]: {
    labelText: "Generar certificado automaticamente",
    uploadInfoText:
      "Subir un certificado aqui solo lo registra en Things OS. Tambien debes subir o aprobar el mismo certificado en la maquina de destino, o la conexion fallara.",
    generatedInfoText:
      "Generar o cargar un certificado aqui solo lo registra en Things OS. Tambien debes cargar o aprobar el mismo certificado en la maquina de destino, o la conexion fallara.",
    reuseGeneratedCertificateHintText:
      "El certificado generado se volvera a usar.",
    infoIconAltText: "Informacion",
  },
};

export const autoGenerateCertificateSettingNl = {
  [pageNameKey]: {
    labelText: "Certificaat automatisch genereren",
    uploadInfoText:
      "Door hier een certificaat te uploaden, wordt het alleen in Things OS geregistreerd. Je moet hetzelfde certificaat ook uploaden of goedkeuren op de doelmachine, anders mislukt de verbinding.",
    generatedInfoText:
      "Door hier een certificaat te genereren of te uploaden, wordt het alleen in Things OS geregistreerd. Je moet hetzelfde certificaat ook uploaden of goedkeuren op de doelmachine, anders mislukt de verbinding.",
    reuseGeneratedCertificateHintText:
      "Het gegenereerde certificaat wordt opnieuw gebruikt.",
    infoIconAltText: "Info",
  },
};

export const autoGenerateCertificateSettingTr = {
  [pageNameKey]: {
    generatedInfoText:
      "Burada bir sertifika oluşturmak veya yüklemek onu yalnızca Things OS'ye kaydeder. Aynı sertifikayı hedef makineye de yüklemeniz veya onaylamanız gerekir, aksi takdirde bağlantı başarısız olur.",
    infoIconAltText: "Bilgi",
    labelText: "Sertifikayı otomatik olarak oluştur",
    reuseGeneratedCertificateHintText:
      "Oluşturulan sertifika tekrar kullanılacak.",
    uploadInfoText:
      "Buraya bir sertifika yüklemek onu yalnızca Things OS'ye kaydeder. Aynı sertifikayı hedef makineye de yüklemeniz veya onaylamanız gerekir, aksi takdirde bağlantı başarısız olur.",
  },
};
